import { render } from "./AuthStatusDisplay.vue?vue&type=template&id=07d273a9&scoped=true"
import script from "./AuthStatusDisplay.vue?vue&type=script&lang=js"
export * from "./AuthStatusDisplay.vue?vue&type=script&lang=js"

import "./AuthStatusDisplay.vue?vue&type=style&index=0&id=07d273a9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07d273a9"]])

export default __exports__